import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _44038886 = () => interopDefault(import('../pages/conference.vue' /* webpackChunkName: "pages/conference" */))
const _22f69120 = () => interopDefault(import('../pages/enterprise-providers.vue' /* webpackChunkName: "pages/enterprise-providers" */))
const _55cc54aa = () => interopDefault(import('../pages/equity-rating.vue' /* webpackChunkName: "pages/equity-rating" */))
const _7ca880ff = () => interopDefault(import('../pages/esg.vue' /* webpackChunkName: "pages/esg" */))
const _64a40b3c = () => interopDefault(import('../pages/health-pays-back.vue' /* webpackChunkName: "pages/health-pays-back" */))
const _7e8321fa = () => interopDefault(import('../pages/leaderboard.vue' /* webpackChunkName: "pages/leaderboard" */))
const _9cbdd178 = () => interopDefault(import('../pages/licensing.vue' /* webpackChunkName: "pages/licensing" */))
const _1f0a4c7c = () => interopDefault(import('../pages/ratings.vue' /* webpackChunkName: "pages/ratings" */))
const _368e9111 = () => interopDefault(import('../pages/recharge.vue' /* webpackChunkName: "pages/recharge" */))
const _7f23cc17 = () => interopDefault(import('../pages/summit.vue' /* webpackChunkName: "pages/summit" */))
const _156990d8 = () => interopDefault(import('../pages/well-ap.vue' /* webpackChunkName: "pages/well-ap" */))
const _4840e756 = () => interopDefault(import('../pages/well-at-scale.vue' /* webpackChunkName: "pages/well-at-scale" */))
const _34d2c01d = () => interopDefault(import('../pages/why-well.vue' /* webpackChunkName: "pages/why-well" */))
const _1c980ea0 = () => interopDefault(import('../pages/testing/recharge.vue' /* webpackChunkName: "pages/testing/recharge" */))
const _0547af50 = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _b186cf36 = () => interopDefault(import('../pages/_.vue' /* webpackChunkName: "pages/_" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/conference",
    component: _44038886,
    name: "conference"
  }, {
    path: "/enterprise-providers",
    component: _22f69120,
    name: "enterprise-providers"
  }, {
    path: "/equity-rating",
    component: _55cc54aa,
    name: "equity-rating"
  }, {
    path: "/esg",
    component: _7ca880ff,
    name: "esg"
  }, {
    path: "/health-pays-back",
    component: _64a40b3c,
    name: "health-pays-back"
  }, {
    path: "/leaderboard",
    component: _7e8321fa,
    name: "leaderboard"
  }, {
    path: "/licensing",
    component: _9cbdd178,
    name: "licensing"
  }, {
    path: "/ratings",
    component: _1f0a4c7c,
    name: "ratings"
  }, {
    path: "/recharge",
    component: _368e9111,
    name: "recharge"
  }, {
    path: "/summit",
    component: _7f23cc17,
    name: "summit"
  }, {
    path: "/well-ap",
    component: _156990d8,
    name: "well-ap"
  }, {
    path: "/well-at-scale",
    component: _4840e756,
    name: "well-at-scale"
  }, {
    path: "/why-well",
    component: _34d2c01d,
    name: "why-well"
  }, {
    path: "/testing/recharge",
    component: _1c980ea0,
    name: "testing-recharge"
  }, {
    path: "/",
    component: _0547af50,
    name: "index"
  }, {
    path: "/*",
    component: _b186cf36,
    name: "all"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
